import React from 'react'
import Component from 'components/component'

class DropdownAudioItem extends Component {
  render() {
    const {
      item,
      index,
      video,
      array,
      title,
      value,
      active,
      onClick,
      isHighlited,
      setRef,
      listsWithVideo,
      onlyArrow,
    } = this.props

    const isChecked = listsWithVideo.includes(item.id)

    return (
      <li
        className="dropdown-item"
        key={value + '-' + title + '-' + index}
        ref={node => setRef(node, index)}
      >
        <a
          href="#"
          className={Component.classList(
            'dropdown__item ',
            active && '_active',
            isChecked && '_checked',
            onlyArrow && '_only-arrow'
          )}
          onClick={ev => ev.preventDefault()}
          onMouseDown={onClick}
          style={isHighlited ? { background: '#77bc1f' } : {}}
        >
          <span className="title">{title}</span>
          <span
            className={Component.classList(
              'title--label',
              item.booked ? 'green' : 'orange'
            )}
          >
            {item.booked ? 'BOOKED' : 'NOT BOOKED'}
          </span>
        </a>
      </li>
    )
  }
}

export default DropdownAudioItem
